/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-16 09:13:50
 * @FilePath: \heshan_web\src\config\website.js
 */

/**
 * 全局配置文件
 */
export default {
  title: "saber",
  logo: "S",
  key: 'saber',
  //配置主键,目前用于存储
  indexTitle: '和山空调远程运维',
  clientId: 'heshan_admin',
  // 客户端id
  clientSecret: 'heshan_secret',
  // 客户端密钥
  tenantMode: true,
  // 是否开启租户模式
  tenantId: "123369",
  // 管理组租户编号
  captchaMode: true,
  // 是否开启验证码模式
  lockPage: '/lock',
  tokenTime: 60,
  tokenHeader: 'Blade-Auth',
  //http的status默认放行列表
  statusWhiteList: [],
  //配置首页不可关闭
  isFirstPage: false,
  fistPage: {
    label: "地图总览",
    value: "/overView/omCenter",
    params: {},
    query: {},
    meta: {
      i18n: 'dashboard'
    },
    group: [],
    close: false
  },
  //配置菜单的属性
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'source',
      children: 'children'
    }
  },
  // 第三方系统授权地址
  authUrl: 'http://localhost/blade-auth/oauth/render',
  // 流程设计器地址
  flowDesignUrl: 'http://localhost:9999',
  // 报表设计器地址(cloud端口为8108,boot端口为80)
  reportUrl: 'http://localhost:8108/ureport'
};